<template>
  <div>
    <header>
      <nav class="navbar navbar-expand-lg navbar-light fixed-top">
        <div class="container">
          <a href="/" class="navbar-brand">
            <img src="amej-pay.png" alt="Amejpay" />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item active">
                <a href="/#" class="nav-link">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#about">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#features">Features</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/#platform">Platform</a>
              </li>
              <div>
                <template v-if="isAuthenticated">
                  <router-link :to="{name: dashboardRoute}" class="login">Dashboard</router-link>
                </template>
                <template v-else>
                  <router-link :to="{name: 'login'}" class="login">Log in</router-link>
                  <br class="d-lg-none" />
                  <router-link :to="{name: 'UserRegister'}" class="signup">Sign Up</router-link>
                </template>
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </header>

    <main></main>
  </div>
</template>

<script type="text/javascript">
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/style.css";
import "bootstrap/dist/js/bootstrap.min.js";
const axios = require("axios");
import { isLoggedIn, isMerchant, dashboardRouteName, rememberRoleFromProfile } from "../../utils/auth";

export default {
  data() {
    return {
      isAuthenticated: isLoggedIn(),
      // Read synchronously from the session captured at login. This used to be
      // decided inside an async profile call, so clicking Dashboard before that
      // resolved sent a MERCHANT to the user dashboard - whose calls then failed
      // and, under the old 401 handler, destroyed the session.
      isMerchantUser: isMerchant(),
    };
  },
  computed: {
    dashboardRoute: function () { return dashboardRouteName(); },
  },
  created(){
    if (!this.isAuthenticated) { return; }
    // Still confirm against the profile, because a role can change - but the link
    // above never waits for it, and a failure here must not break the page.
    const vm = this;
    axios.get("profile")
      .then(function (response) {
        if (response && response.status === 200 && response.data) {
          rememberRoleFromProfile(response.data);
          vm.isMerchantUser = isMerchant();
        }
      })
      .catch(function () {
        // 401 is handled globally by the refresh interceptor. Anything else just
        // leaves the persisted role in place - it was right a moment ago.
      });
  }
};
</script>